import { Size } from '@vivli/shared/theme';
import { DefaultBasicDataPackageListComponent, DefaultFullDataPackageListComponent } from '@vivli/features/studies/components';
import React from 'react';

interface DefaultDataPackageListComponentProps {
    isFull?: boolean;
}

export const DefaultDataPackageListComponent: React.FC<DefaultDataPackageListComponentProps> = ({ isFull = false }) => {
    return (
        <div>
            <div
                style={{
                    paddingLeft: '10px',
                    paddingRight: Size.PADDING,
                }}
            >
                {!isFull && (
                    <div>
                        Basic Data Packages must include:
                        {<DefaultBasicDataPackageListComponent />}
                    </div>
                )}
                {isFull && (
                    <div>
                        Expanded Data Packages must include:
                        <DefaultFullDataPackageListComponent />
                    </div>
                )}
            </div>
        </div>
    );
};
